import { render, staticRenderFns } from "./dashBroad.vue?vue&type=template&id=a20b9faa&scoped=true"
import script from "./dashBroad.vue?vue&type=script&lang=js"
export * from "./dashBroad.vue?vue&type=script&lang=js"
import style0 from "./dashBroad.vue?vue&type=style&index=0&id=a20b9faa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20b9faa",
  null
  
)

export default component.exports